export function runConditionalRangeValidation(
  sender: any,
  q: any,
  options: any,
): boolean {
  // ---------------------------
  // CONDITIONAL RANGE
  // ---------------------------
  if (
    q.validationType === "conditional-range" &&
    q.conditionalRangeRules &&
    q.conditionalRangeBaseQuestion
  ) {
    const baseVal = sender.getValue(q.conditionalRangeBaseQuestion);
    if (baseVal == null) return true;

    const rules = String(q.conditionalRangeRules)
      .split("\n")
      .map((r) => r.trim())
      .filter(Boolean);

    for (const rule of rules) {
      const m = rule.match(
        /^(.*?):\s*([-+]?\d+(?:\.\d+)?)\s*-\s*([-+]?\d+(?:\.\d+)?)$/,
      );
      if (!m) continue;

      const option = m[1].trim();
      const min = Number(m[2]);
      const max = Number(m[3]);
      const val = Number(options.value);

      if (String(baseVal) === option) {
        if (Number.isNaN(val)) {
          options.error = `Value must be a number when ${option} is selected.`;
          return false;
        }

        if (val < min || val > max) {
          options.error = `Value must be between ${min} and ${max} when ${option} is selected.`;
          return false;
        }
      }
    }
  }

  // ---------------------------
  // ROW RANGE (MATRIX)
  // ---------------------------
  if (q.validationType === "row-range" && q.rowRangeRules) {
    const rawRows = sender.getValue(q.name);
    if (!rawRows) return true;

    const rows = Array.isArray(rawRows) ? rawRows : Object.values(rawRows);

    const rules = String(q.rowRangeRules)
      .split("\n")
      .map((r) => r.trim())
      .filter(Boolean);

    for (const rule of rules) {
      const m = rule.match(
        /^(.*?):\s*([-+]?\d+(?:\.\d+)?)\s*-\s*([-+]?\d+(?:\.\d+)?)$/,
      );
      if (!m) continue;

      const col = m[1].trim();
      const min = Number(m[2]);
      const max = Number(m[3]);

      let total = 0;
      rows.forEach((r: any) => {
        const v = Number(r?.[col]);
        if (!Number.isNaN(v)) total += v;
      });

      if (total < min || total > max) {
        options.error = `Total for ${col} must be between ${min} and ${max}.`;
        return false;
      }
    }
  }

  return true;
}

/**
 * Handles Regex and "Contains" (Exact Match) validation logic.
 */
export function runValueValidation(sender: any, q: any, options: any): boolean {
  if (q.validationType !== "value") return true;

  // 2. Value Contains (Exact Match from comma-separated list)
  if (q.AcceptedInputs) {
    const isSuccess = runValueContainsValidation(q, options.value);
    if (!isSuccess) {
      const allowed = q.AcceptedInputs.split(",")
        .map((v: string) => v.trim())
        .filter(Boolean);
      options.error =
        q.valueCustomError || `Value must be one of  : ${allowed.join(", ")}`;
      return false;
    }
  }

  return true;
}

/**
 * Logic specifically for checking if a value exists in the comma-separated string
 */
export function runValueContainsValidation(q: any, value: any): boolean {
  if (!q.AcceptedInputs) return true;

  const userValue = String(value || "").trim();
  const allowedValues = q.AcceptedInputs.split(",")
    .map((v: string) => v.trim())
    .filter((v: string) => v !== "");

  // Returns true if match found, false otherwise
  return allowedValues.includes(userValue);
}

export function runMinMaxValidation(
  sender: any,
  q: any,
  options: any,
): boolean {
  const value = options.value;

  if (value === null || value === undefined || value === "") return true;

  const numericValue = Number(value);
  if (isNaN(numericValue)) return true;

  if (q.customMin !== undefined && numericValue < q.customMin) {
    options.error =
      q.customMinError || `Minimum value should be ${q.customMin}`;
    return false;
  }

  if (q.customMax !== undefined && numericValue > q.customMax) {
    options.error =
      q.customMaxError || `Maximum value should be ${q.customMax}`;
    return false;
  }

  return true;
}
